export default __webpack_public_path__ + "static/1_7-205c6e1cf88f5fb991e4996fec54fd3b.png";